import CategoryInput from '@/core/components/inputs/CategoryInput/CategoryInput';

export default CategoryInput;
